import { render, staticRenderFns } from "./DetailLabelDialog.vue?vue&type=template&id=4b6ad958"
import script from "./DetailLabelDialog.vue?vue&type=script&lang=js"
export * from "./DetailLabelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports